<app-header
  *ngIf="
    deviceType == 'TabletPortrait' ||
    deviceType == 'TabletLandscape' ||
    deviceType == 'WebPortrait' ||
    deviceType == 'WebLandscape'
  "
></app-header>
<app-sidebar></app-sidebar>
